import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setUserSituation } from "./../store.js"
import { Form, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './ChatSituation.css';

function ChatSituation() {
  const navigate = useNavigate();
  let dispatch = useDispatch()
  let userSituation = useSelector((state) => state.userSituation ) //聊天情景设置
  const [situationInput, setSituationInput] = useState(''); // add state variable

  const handleFormSubmit = () => {
    dispatch(setUserSituation(situationInput)); // dispatch the form content to Redux store
  };

  return (
    <div className="ChatSituation">
      {/*
      <div className="container">
        <form className="userForm">
          <div>
            <h3>请告诉我你想练习的对话情景！</h3>
            <input placeholder="例）我想练习OPIc对话" />
            <button type="submit" id="submitBtn" className="click">下一步</button>
          </div>
        </form>
      </div>
  */}

      <Form className="userForm">
        <Col>
            <Form.Group as={Row} className="mb-3" controlId="">
            <Col sm>
              <Form.Label className="formTitle">请告诉我你想进行对话的情景！</Form.Label>
              <p className="formDesc">越具体地输入情景，就能进行越符合你期望的对话</p>
              <Form.Control as="textarea" placeholder="例）我想练习OPIc对话" className="situationInput" value={situationInput} onChange={(event) => setSituationInput(event.target.value)} /> 
            </Col>
            </Form.Group>

            <button className="mainBtn" onClick={() =>{ handleFormSubmit(); navigate('/chatWithTutorSitu')}}>
                以上情景开始对话！
            </button>
        </Col>
      </Form>
    </div>
  );
}

export default ChatSituation;